import React from 'react';

// @source
import { path } from '../../../../utils';
import { Fragment } from '../../../components';
import Chart from '../../Trend/components/Chart';

// eslint-disable-next-line no-unused-vars
const Info = () => (
  <table>
    <tbody>
      <tr>
        <td><p>columns</p></td>
        <td><p>{decodeURIComponent(path.parse('columns'))}</p></td>
      </tr>
      <tr>
        <td><p>query</p></td>
        <td><p>{decodeURIComponent(path.parse('query'))}</p></td>
      </tr>
      <tr>
        <td><p>token</p></td>
        <td><p>{decodeURIComponent(path.parse('token'))}</p></td>
      </tr>
      <tr>
        <td><p>type</p></td>
        <td><p>{path.parse('type')}</p></td>
      </tr>
    </tbody>
  </table>
);

const Trend = () => (
  <Fragment>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />
    {/* <Info /> */}
    <Chart
      isMobile
      columns={decodeURIComponent(path.parse('columns')).split(',')}
      query={decodeURIComponent(path.parse('query'))}
      token={window.parseInt(decodeURIComponent(path.parse('token')))}
      type={path.parse('type')}
    />
  </Fragment>
);

export default Trend;
